import React from 'react';
import './Contact.css';
import { trackButtonClick } from '../../utils/analytics';

const Contact: React.FC = () => {
  const handleEmailClick = () => {
    trackButtonClick('email', 'contact', 'contact_click');
  };

  const handlePhoneClick = () => {
    trackButtonClick('phone', 'contact', 'contact_click');
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <div className="contact-header">
          <h2 className="contact-heading">Get in Touch</h2>
          <p className="contact-subheading">
            Have questions? We'd love to hear from you. Reach out to us using the contact information below.
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-info-card">
              <div className="contact-info-icon">📧</div>
              <h3 className="contact-info-title">Email</h3>
              <a href="mailto:Paulfortuneltd@gmail.com" className="contact-info-link" onClick={handleEmailClick}>
                Paulfortuneltd@gmail.com
              </a>
            </div>
            <div className="contact-info-card">
              <div className="contact-info-icon">📱</div>
              <h3 className="contact-info-title">Phone</h3>
              <a href="tel:+447737024736" className="contact-info-link" onClick={handlePhoneClick}>
                +44 7737 024736
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
